<div class="form-control multi-dropdown" [class.disabled]="disabled" [attr.aria-describedby]="ariaDescribedby">
  <ng-container *ngFor="let item of internalItems">
    <span *ngIf="item.selected" class="badge badge-pill badge-secondary">
      <ng-container *ngIf="debugMode">({{item.key}}) </ng-container>{{item.text}}
      <button class="multi-dropdown-unselect" type="button" [disabled]="disabled" (click)="onToggle(item.key)"
        aria-label="Unselect">
        <span aria-hidden="true">&times;</span>
      </button>
    </span>
  </ng-container>
</div>

<div class="input-group-append" #dropDown="ngbDropdown" ngbDropdown autoClose="outside" placement="bottom-right">
  <button class="btn btn-outline-secondary dropdown-toggle" type="button" [disabled]="disabled"
    ngbDropdownToggle></button>
  <div ngbDropdownMenu>

    <div *ngFor="let item of internalItems" class="dropdown-item" (click)="mimicClickOnLabel(item.key, $event)">
      <div class="custom-control custom-checkbox" (click)="mimicClickOnLabel(item.key, $event)">
        <input type="checkbox" class="custom-control-input" [disabled]="disabled" (change)="onToggle(item.key)"
          [checked]="item.selected" [id]="getItemId(item)">
        <label class="custom-control-label" [for]="getItemId(item)" (click)="onClickLabel(item.selected, $event)">
          <ng-container *ngIf="debugMode">({{item.key}}) </ng-container>
          {{item.text}}
        </label>
      </div>
    </div>

  </div>
</div>